// 3rd party
import { Component, OnInit } from '@angular/core';

// components
import { LayoutMainComponent } from 'app/shared/layout/layout-main/layout-main.component';
import { AppComponent } from 'app/app.component';

// models
import { ContactCustomer, ERoleActionWebview } from 'app/shared/models/contact-customer.model';

@Component({
  selector: 'app-layout-main-nav',
  templateUrl: './layout-main-nav.component.html',
  styleUrls: ['./layout-main-nav.component.css']
})
export class LayoutMainNavComponent implements OnInit {

  hasAccessAssays: boolean;
  hasAccessBudgets: boolean;
  hasAccessCalibrations: boolean;
  hasAccessInstruments: boolean;
  hasAccessReports: boolean;
  hasAccessStandards: boolean;

  constructor(
    public app: AppComponent,
    public layoutMain: LayoutMainComponent
  ) {
    this.checkAccess();
  }

  ngOnInit() { }

  checkAccess() {
    let contact = JSON.parse(localStorage.getItem('currentContact')) as ContactCustomer;

    // calibrations
    let requiredCalibrationPermissions: ERoleActionWebview[] = [ERoleActionWebview.CertificatesList];
    this.hasAccessCalibrations = ContactCustomer.hasPermissions(requiredCalibrationPermissions, contact.RoleWebView.ActionsPermissions);

    // instruments
    let requiredInstrumentPermissions: ERoleActionWebview[] = [ERoleActionWebview.InstrumentsList];
    this.hasAccessInstruments = ContactCustomer.hasPermissions(requiredInstrumentPermissions, contact.RoleWebView.ActionsPermissions);

    // budgets
    let requiredBudgetsPermissions: ERoleActionWebview[] = [ERoleActionWebview.BudgetsList];
    this.hasAccessBudgets = ContactCustomer.hasPermissions(requiredBudgetsPermissions, contact.RoleWebView.ActionsPermissions);

    // standards
    let requiredStandardsPermissions: ERoleActionWebview[] = [ERoleActionWebview.StandardsList];
    this.hasAccessStandards = ContactCustomer.hasPermissions(requiredStandardsPermissions, contact.RoleWebView.ActionsPermissions);

    // reports
    let requiredReportsPermissions: ERoleActionWebview[] = [ERoleActionWebview.ReportsList];
    this.hasAccessReports = ContactCustomer.hasPermissions(requiredReportsPermissions, contact.RoleWebView.ActionsPermissions);

    // samples
    this.hasAccessAssays = JSON.parse(localStorage.getItem('assayAccess')) || false;
  }

  toggleSidenav() {
    this.layoutMain.sidenav.toggle();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/layout-main-nav/layout-main-nav.component.ts